var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col"},[_c('label',{class:_vm.valueToggle ? 'toggle-box-active' : 'toggle-box',style:(_vm.corSecundaria),on:{"click":function($event){_vm.valueToggle = !_vm.valueToggle}}},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }